/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useChartData } from "../data/useChartData";
import { useHighchartTransformer } from "../transformers/useHighchartTransformer";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from "../../../../charts/components/HighchartsChart";
import { ComponentContextReadyState } from "@sa/rep-core";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { useParameter, useSubscriptionSource } from "../../../shared";
import { useExportSource } from "../hooks/useExportSource";

export const ComponentChart: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResult = useHookSubscribe(null, context.olapResult$);
  const source = useHookSubscribe(null, context.sources$);
  const [methodId] = useParameter<number>("@method");
  const isMethodIndex = methodId === 2;
  useExportSource(source);
  useSubscriptionSource(source);

  const chartData = useChartData(olapResult);
  const highchartData = useHighchartTransformer(chartData);

  if (window["exportMode"]) {
    window["exportReady"] = highchartData && context.readyState !== ComponentContextReadyState.Loading;
  }

  if (!highchartData || context.readyState === ComponentContextReadyState.Loading) {
    return <ComponentPreloader />;
  }
  return (
    <>
      <ComponentSourcetitle>Source: {source}</ComponentSourcetitle>
      <ComponentFootnote>{isMethodIndex ? "%" : "USD/mt"}</ComponentFootnote>
      <HighchartsChart data={highchartData} loader={<ComponentPreloader />} />
    </>
  );
};
